<template>
  <div class="charts">
    <el-card>
      <el-form :model="searchInfo" :inline="true">
        <el-form-item label="日期">
          <el-date-picker
              v-model="searchInfo.dateRange"
              :picker-options="pickerOptions"
              value-format="timestamp"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              clearable
              editable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="对冲产品:">
          <el-select v-model="searchInfo.hedgeProductType" clearable placeholder="请选择对冲产品">
            <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标类型:">
          <el-select v-model="searchInfo.hedgeTargetType" clearable placeholder="请选择对冲目标类型">
            <el-option v-for="item in hedgeTargetTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对冲目标值:">
          <el-input v-model="searchInfo.hedgeTargetValue" placeholder="请输入对冲目标类值"></el-input>
        </el-form-item>
        <el-form-item label="交易对:">
          <el-select v-model="searchInfo.pair" style="width: 350px" clearable multiple allow-create filterable placeholder="请输入交易对">
            <el-option v-for="item in allSymbols" :key="item" :label="item" :value="item">{{item}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间粒度:">
          <el-select v-model="searchInfo.timeInterval" clearable>
            <el-option label="1小时" :value="1">1小时</el-option>
            <el-option label="4小时" :value="4">4小时</el-option>
            <el-option label="1天" :value="24">1天</el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :plain="true" @click="getList">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="chart-content">
        <div class="chart" ref="chart1"></div>
        <div class="chart" ref="chart2"></div>
        <div class="chart" ref="chart3"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Echart from 'echarts';
import api from './utils'
const hedgeTargetTypeSPOTOptions = [
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeSUPER_CONTRACTOptions = [
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
export default {
  name: "HedgingChart",
  data() {
    return {
      searchInfo: {
        dateRange: '',
        hedgeProductType: 'SPOT',
        hedgeTargetType: '',
        hedgeTargetValue: '',
        pair: [],
        settlement: false,
        timeInterval: ''
      },
      hedgeTargetTypeEnum: hedgeTargetTypeSPOTOptions,
      chartList: []
    }
  },
  computed: {
    ...mapState('newHedgeStore', ['hedgeProductTypeOptions', 'pickerOptions']),
    ...mapState(['allSymbols'])
  },
  watch: {
    'searchInfo.hedgeProductType'(val) {
      this.searchInfo.hedgeTargetType = ''
      this.hedgeTargetTypeEnum = val === 'SPOT' ? hedgeTargetTypeSPOTOptions : hedgeTargetTypeSUPER_CONTRACTOptions
    }
  },
  created() {
    this.$store.dispatch('getAllSymbols')
    window.addEventListener('resize', () => {
      this.chartList.forEach(item => {
        item.resize()
      })
    })
  },
  methods: {
    async getList() {
      if (!this.searchInfo.dateRange) {
        return this.$message({ message: '请选择时间', type: 'warning' })
      }
      const sendData = JSON.parse(JSON.stringify(this.searchInfo))
      sendData.startTime = new Date(sendData.dateRange[0]).getTime()
      sendData.endTime = new Date(sendData.dateRange[1]).getTime()
      sendData.pair = sendData.pair.join(',')
      delete sendData.dateRange
      const { data } = await api.getChartInfo({...sendData})
      const map = {
        'inchBear': { el: 'chart1', title: '空头头寸价值' },
        'inchBull': { el: 'chart2', title: '多头头寸价值' },
        'totalProfit': { el: 'chart3', title: '总净利润（总固定盈亏+需对冲浮动盈亏）', tip: '总净利润' }
      }
      for (let k in map) {
        if (data[k]) {
          const xAxis = []
          const series = []
          for (const item of data[k]) {
            for (const [key, value] of Object.entries(item)) {
              xAxis.push(key)
              series.push(value)
            }
          }
          this.setChart(map[k].el, map[k].title, xAxis, series, map[k].tip)
        }
      }
    },
    setChart(el, title, xAxisData, seriesData, tip) {
      const option = {
        grid: {
          left: '10',
          right: '10',
          top: '30',
          bottom: '30',
          containLabel: true
        },
        dataZoom: [{
          type: 'inside',
          show: false,
          start: 0,
          end: 15 / xAxisData.length * 100,
          // zoomLock: true
        }],
        xAxis: {
          type: 'category',
          axisLabel: { rotate: 45 },
          axisTick:{ show: false }, // 不显示刻度线
          axisLine: { show: false, }, //不显示坐标线
          data: xAxisData,
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          axisPointer: {
            type: 'shadow',
            crossStyle: { color: '#ff0' }
          },
          textStyle: {
            fontSize: 14,
            color: '#fff'
          },
          formatter: function(val) {
            const title = tip ? tip : val[0].seriesName
            return `<p>${val[0].axisValue}</p><p class="toolTip">${title}: ${val[0].data}USDT</p>`
          }
        },
        yAxis: {
          name: title,
          type: 'value',
          nameTextStyle:{
            padding:tip ? [0,0,0,152] : 0
          },
          axisTick:{ show: false }, // 不显示刻度线
          axisLine: { show: false, }, //不显示坐标线
          axisLabel: { formatter: '{value} USDT' },
        },
        formatter: function (val) {
          return val + 'USDT'
        },
        series: [
          {
            name: title,
            type: 'line',
            smooth: true,
            data: seriesData
          }
        ]
      }
      this[el] = Echart.init(this.$refs[el])
      this[el].setOption(option)
      this.chartList.push(this[el])
    }
  },
}
</script>

<style scoped lang="less">
.chart-content {
  overflow: hidden;
  .chart {
    height: 300px;
    width: 50%;
    float: left;
  }
}
</style>